
import TickTock from './TickTock';



function App () {
	return (
		<div className="App">
			<TickTock />
		</div>
	);
}

export default App;
